import Entity from '../../../../core/domain/entity';
import UniqueEntityID from '../../../../core/domain/unique_entity_id';
import { DiaryType } from '../../../tracker/domain/diary_type/diary_type';

export interface FavoriteDiaryDescriptionProps {
  title: string;
  content: string;
}

export interface FavoriteDiaryProps {
  descriptions: FavoriteDiaryDescriptionProps[];
  diaryType: DiaryType;
}

export class FavoriteDiaryId extends Entity<unknown> {
  private constructor(id?: UniqueEntityID) {
    super(null, id);
  }

  public static create(id?: UniqueEntityID): FavoriteDiaryId {
    return new FavoriteDiaryId(id);
  }
}

export class FavoriteDiary extends Entity<FavoriteDiaryProps> {
  get favoriteDiaryId(): FavoriteDiaryId {
    return FavoriteDiaryId.create(this.id);
  }

  get descriptions() {
    return this.props.descriptions;
  }

  get diaryType() {
    return this.props.diaryType;
  }

  private constructor(props: FavoriteDiaryProps, id?: UniqueEntityID) {
    super(props, id);
  }

  public static create(
    props: FavoriteDiaryProps,
    id?: UniqueEntityID,
  ): FavoriteDiary {
    return new FavoriteDiary(props, id);
  }
}
